import type { ReactNode } from "react";

import { cn } from "@/utils/cn";

// Figma: https://www.figma.com/design/HJIp5P6tyeFrUd7ODqeWdM/-PROD--Fertility-V?node-id=4809-140892

type CardProps = {
  children: ReactNode;
  /** Layout only: gap, width, grid placement. */
  className?: string;
};

// Display component, no ref forwarded. See ui/README.md.
export const Card = ({ children, className }: CardProps) => (
  <div
    className={cn(
      "rounded-ds-corner-large bg-ds-background-primary px-ds-space-06 py-ds-space-07",
      className
    )}
  >
    {children}
  </div>
);
